var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-box" },
    [
      _vm._l(_vm.chatList, function (item, index) {
        return [
          item.role === "assistant"
            ? _c(
                "div",
                { key: index, staticClass: "chat-item" },
                [
                  _vm.showPortrait
                    ? _c("yxtf-portrait", {
                        staticClass: "portrait",
                        attrs: { size: "28px", imgUrl: _vm.serviceImg },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "chat-core",
                      class: {
                        "has-portrait": _vm.showPortrait,
                        "chat-core-loading":
                          _vm.loading &&
                          index === _vm.chatList.length - 1 &&
                          item.content === "",
                      },
                    },
                    [
                      (item.type = "chat" && index === _vm.chatList.length - 1)
                        ? _c(
                            "div",
                            _vm._l(_vm.receiveStatus, function (num) {
                              return _c(
                                "div",
                                { key: num, staticClass: "chat-status-item" },
                                [
                                  num < 4
                                    ? [
                                        num == _vm.receiveStatus
                                          ? _c("i", {
                                              staticClass: "yxt-icon-loading",
                                            })
                                          : _c("i", {
                                              staticClass: "yxt-icon-check",
                                            }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.receiveStatus === 4 &&
                                                num === 3
                                                ? _vm.RECEIVE_STATUS_MAP[
                                                    _vm.receiveStatus
                                                  ]
                                                : _vm.RECEIVE_STATUS_MAP[num]
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "chat-content" }, [
                        _c("div", { staticClass: "chat-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "chat-msg",
                              staticStyle: { "min-width": "100px" },
                            },
                            [
                              _vm.loading &&
                              index === _vm.chatList.length - 1 &&
                              item.content === ""
                                ? _c("div", { staticClass: "chat-loading" }, [
                                    _c("span", { staticClass: "loading-dot" }),
                                    _c("span", { staticClass: "loading-dot" }),
                                    _c("span", { staticClass: "loading-dot" }),
                                  ])
                                : _vm._e(),
                              item.type === "staffservice"
                                ? _vm._t("staffservice", null, null, {
                                    index: index,
                                    data: item,
                                  })
                                : _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.formatContent(item.content)
                                      ),
                                    },
                                  }),
                            ],
                            2
                          ),
                          (item.type === "chat" &&
                            index !== _vm.chatList.length - 1) ||
                          item.appraisement
                            ? _c(
                                "div",
                                { staticClass: "top-option" },
                                [
                                  _vm._t("top-option", null, null, {
                                    index: index,
                                    data: item,
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                          item.appraisement
                            ? _c(
                                "div",
                                { staticClass: "status" },
                                [
                                  _c("yxtf-svg", {
                                    attrs: {
                                      width: "20px",
                                      height: "20px",
                                      "remote-url": _vm.ICON_PATH,
                                      "icon-class":
                                        item.appraisement === 1
                                          ? "great"
                                          : "bad",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        index === _vm.chatList.length - 1 &&
                        !_vm.loading &&
                        item.type === "chat"
                          ? _c(
                              "div",
                              { staticClass: "option" },
                              [
                                _vm._t("option", null, null, {
                                  index: index,
                                  data: item,
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                { key: index + "user", staticClass: "chat-item right" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "chat-content",
                      class: { "has-portrait": _vm.showPortrait },
                    },
                    [
                      _c("div", { staticClass: "chat-msg mr-3" }, [
                        _vm._v(_vm._s(item.content)),
                      ]),
                    ]
                  ),
                  _vm.showPortrait
                    ? _c("yxtf-portrait", {
                        staticClass: "portrait",
                        attrs: { size: "28px", imgUrl: _vm.userImg },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }